import React, { useState } from 'react';
import ReportIssueModal from './ReportIssueModal';

/**
 * Reusable button component to report issues with MCQ/True-False questions
 * 
 * Usage example:
 * <ReportIssueButton
 *   questionData={{ question: "...", options: [...], correctAnswer: 0 }}
 *   sourceType="quiz"
 *   sourceId={quizId}
 *   questionPath="question3"
 *   questionId={question._id}
 *   questionIndex={2}
 *   metadata={{ sourceName: "Quiz Title", sourceCode: "QUIZ123" }}
 *   size="small" // or "medium" or "icon-only"
 * />
 */
function ReportIssueButton({
  questionData,
  sourceType,
  sourceId,
  questionPath,
  questionId,
  questionIndex,
  metadata,
  size = 'small', // 'small', 'medium', 'icon-only'
  style = {},
  className = ''
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const buttonStyles = {
    'icon-only': {
      padding: '6px 10px',
      fontSize: '18px',
      border: '1px solid #e2e8f0',
      background: '#f7fafc',
      cursor: 'pointer',
      color: '#718096',
      borderRadius: '6px',
      transition: 'all 0.2s',
      lineHeight: '1',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    small: {
      padding: '4px 10px',
      fontSize: '11px',
      fontWeight: '600',
      color: '#718096',
      backgroundColor: '#f7fafc',
      border: '1px solid #e2e8f0',
      borderRadius: '6px',
      cursor: 'pointer',
      transition: 'all 0.2s'
    },
    medium: {
      padding: '8px 14px',
      fontSize: '13px',
      fontWeight: '600',
      color: '#718096',
      backgroundColor: '#f7fafc',
      border: '1px solid #e2e8f0',
      borderRadius: '6px',
      cursor: 'pointer',
      transition: 'all 0.2s'
    }
  };

  const hoverStyle = `
    .report-issue-btn:hover {
      background-color: #fed7d7 !important;
      border-color: #fc8181 !important;
      color: #c53030 !important;
    }
  `;

  return (
    <>
      <style>{hoverStyle}</style>
      <button
        className={`report-issue-btn ${className}`}
        onClick={(e) => {
          e.stopPropagation(); // Prevent any parent click handlers
          setIsModalOpen(true);
        }}
        style={{ ...buttonStyles[size], ...style }}
        title="Report an issue with this question"
      >
        🚩 {size !== 'icon-only' && 'Report Issue'}
      </button>

      <ReportIssueModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        questionData={questionData}
        sourceType={sourceType}
        sourceId={sourceId}
        questionPath={questionPath}
        questionId={questionId}
        questionIndex={questionIndex}
        metadata={metadata}
      />
    </>
  );
}

export default ReportIssueButton;
